import React, { useState } from 'react';

// import image from "./../images/wallet.avif";



const Payhis = () => {
    const [activeTab, setActiveTab] = useState('Overview');

    const [data, setData] = useState([
        {
            SNo: '1',
            order: '12345',
            transcation: 'IC-8456125',
            date: '27/03/2025',
            name: 'Rahul',
            payment: 'UPI',
            status: 'success',
            Amount: '₹500',
        },
        {
            SNo: '1',
            order: '12345',
            transcation: 'IC-8456125',
            date: '27/03/2025',
            name: 'Rahul',
            payment: 'UPI',
            status: 'success',
            Amount: '₹500',
        },
    ]);

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const updatedData = [...data];
        updatedData[index][name] = value;
        setData(updatedData);
    };

    const handleAddRow = () => {
        const newRow = {
            SNo: (data.length + 1).toString(),
            category: '',
            type: '',
            image: '',
            name: '',
            price: '',
            price1: '',
        };
        setData([...data, newRow]);
    };

    const handleDeleteRow = (index) => {
        const updatedData = data.filter((_, i) => i !== index);
        setData(updatedData);
    };
    // {=======================overview===============================}
    const tabContent = {
        Overview: <div>
            <div className="status-overview">
                <div style={{ background: "#2c6eaa", color: "#fff" }} className="status-card dine-in">
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "30px", marginTop: '20px' }}>
                        {/* <img src={image} alt="imag" style={{ height: '50px', borderRadius: '10px' }} /> */}
                    </div>
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Total Income</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>₹3,00,000.00</p>
                </div>
                <div style={{ background: "#3498db", color: "#fff", marginLeft: "-190px" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center", marginTop: '20px', marginBottom: "30px" }}>Food</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Income: ₹1,00,000.00</p>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Revenue: 52%</p>
                </div>
            </div>
            <div>
                <h4 style={{ display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "10px" }}>Payment History</h4>
                <div style={{ display: "flex", gap: "10px", justifyContent: "space-between", }}>
                    <div>
                        <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
                            <option value="yearly">Yearly</option>
                            <option value="yearly">2023</option>
                            <option value="yearly">2024</option>
                            <option value="yearly">2025</option>
                        </select>
                        <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
                            <option value="yearly">Monthly</option>
                            <option value="yearly">Jan</option>
                            <option value="yearly">Feb</option>
                            <option value="yearly">Mar</option>
                        </select>
                        <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
                            <option value="yearly">Weekly</option>
                            <option value="yearly">sun</option>
                            <option value="yearly">Mon</option>
                            <option value="yearly">Tues</option>
                        </select>
                        <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
                            <option value="yearly">Today</option>
                            <option value="yearly">Yesterday</option>
                            <option value="yearly">25/03/25</option>
                            <option value="yearly">24/03/25</option>
                        </select>
                    </div>
                    {/* <button style={{ height: '35px', marginTop: "0px", borderRadius: "4px", border: "none", backgroundColor: "#b15cd6", color: "white", fontWeight: 'bold', }}>Export</button> */}
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f2f2f2' }}>
                            <th style={tableHeaderStyle}>S.No</th>
                            <th style={tableHeaderStyle}>Order ID</th>
                            <th style={tableHeaderStyle}>Transcation ID</th>
                            <th style={tableHeaderStyle}>Date&Time</th>
                            <th style={tableHeaderStyle}>Name</th>
                            <th style={tableHeaderStyle}>Payment Method</th>
                            <th style={tableHeaderStyle}>status</th>
                            <th style={tableHeaderStyle}>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index} style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
                                <td style={tableCellStyle}>{item.SNo}</td>
                                <td style={tableCellStyle}>{item.order}</td>
                                <td style={tableCellStyle}>{item.transcation}</td>
                                <td style={tableCellStyle}>{item.date}</td>
                                <td style={tableCellStyle}>{item.name}</td>
                                <td style={tableCellStyle}>{item.payment}</td>
                                <td style={tableCellStyle}>{item.status}</td>
                                <td style={tableCellStyle}>{item.Amount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>,
        // {=======================all===============================}
    };

    return (
        <div style={{ overflowY: 'auto', height: '550px', marginTop: '30px', scrollbarWidth: "none" }}>
            {/* Tab Buttons */}
            <div style={{ gap: '10px', display: 'flex', justifyContent: 'space-evenly' }}>
                {Object.keys(tabContent).map((label) => (
                    <button
                        key={label}
                        onClick={() => setActiveTab(label)}
                        style={{
                            border: 'none',
                            borderRadius: '10px',
                            width: '100px',
                            height: '40px',
                            backgroundColor: activeTab === label ? '#b15cd6' : '#d9d9d9',
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                    >
                        {label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div style={{ marginTop: '20px', borderRadius: '8px' }}>
                {tabContent[activeTab]}
            </div>
        </div>
    );
};

const tableHeaderStyle = {
    padding: '12px',
    border: '1px solid #ddd',
    textAlign: 'center',
    fontWeight: 'bold',
    backgroundColor: '#b15cd6',
    color: 'white',
};

const tableCellStyle = {
    padding: '12px',
    border: '1px solid #ddd',
    textAlign: 'center',
};

const evenRowStyle = {
    backgroundColor: '#f9f9f9',
};

const oddRowStyle = {
    backgroundColor: '#fff',
};
const inputStyle = {
    width: '100%',
    border: 'none',
    backgroundColor: 'transparent',
    textAlign: 'center',
};

export default Payhis;

